import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useFeatureFlags } from '@/contexts/FeatureFlagContext';
import { firstAccessibleModulePath } from '@/lib/modulePaths';

/**
 * Requires: feature flag on, user has module in allowedModules (from server).
 * Settings and similar routes should not use this unless you add a module id.
 */
export function AccessGate({ feature, children, fallback = null }) {
  const { hasModule, user } = useAuth();
  const { isFeatureEnabled } = useFeatureFlags();

  if (!user) {
    return fallback ?? null;
  }
  if (!isFeatureEnabled(feature)) {
    return fallback ?? <Navigate to="/dashboard" replace />;
  }
  if (!hasModule(feature)) {
    const to = firstAccessibleModulePath(user.allowedModules);
    return fallback ?? <Navigate to={to} replace />;
  }
  return <>{children}</>;
}
